import React from "react";

export default function ProgressRing({ value = 0, max = 100, size = 140, stroke = 10, label, sub, className = "" }) {
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const pct = Math.min(1, Math.max(0, value / max));
  const offset = circ * (1 - pct);
  return (
    <div className={`relative flex flex-col items-center justify-center ${className}`} data-testid="progress-ring">
      <svg width={size} height={size} className="ring-glow">
        <defs>
          <linearGradient id="ringGradient" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#FF8A00" />
            <stop offset="100%" stopColor="#E52E71" />
          </linearGradient>
        </defs>
        <circle cx={size/2} cy={size/2} r={radius} stroke="#1a1a1a" strokeWidth={stroke} fill="none" />
        <circle
          cx={size/2} cy={size/2} r={radius}
          stroke="url(#ringGradient)"
          strokeWidth={stroke}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circ}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.8s ease" }}
          transform={`rotate(-90 ${size/2} ${size/2})`}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="font-display text-3xl sm:text-4xl leading-none">{Math.round(pct * 100)}<span className="text-base text-white/50">%</span></div>
        {label && <div className="text-[10px] tracking-[0.22em] uppercase text-white/50 mt-1">{label}</div>}
        {sub && <div className="text-xs text-white/60 mt-0.5">{sub}</div>}
      </div>
    </div>
  );
}
